import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/all' },
  { label: '排行榜', href: '/category/all?sort=ranking' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-white">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span className={`font-heading text-xl whitespace-nowrap transition-colors duration-200 ${
            isScrolled || !isHome ? 'text-foreground-900' : 'text-white'
          }`}>
            韩漫网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                location.pathname === link.href || (link.href !== '/' && location.pathname.startsWith(link.href))
                  ? isScrolled || !isHome
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-white/20 text-white'
                  : isScrolled || !isHome
                    ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <div className={`hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full border text-sm ${
            isScrolled || !isHome
              ? 'border-background-200 bg-background-100 text-foreground-500'
              : 'border-white/30 bg-white/10 text-white/70'
          }`}>
            <i className="ri-search-line text-sm"></i>
            <input
              type="text"
              placeholder="搜索漫画..."
              className={`bg-transparent border-none outline-none w-32 text-sm placeholder-current ${
                isScrolled || !isHome ? '' : 'placeholder-white/50'
              }`}
            />
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
              isScrolled || !isHome
                ? 'text-foreground-700 hover:bg-background-100'
                : 'text-white hover:bg-white/10'
            }`}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`block px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === link.href || (link.href !== '/' && location.pathname.startsWith(link.href))
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="mt-3 px-4">
            <div className="flex items-center gap-2 px-3 py-2 rounded-full border border-background-200 bg-background-100 text-foreground-500 text-sm">
              <i className="ri-search-line text-sm"></i>
              <input
                type="text"
                placeholder="搜索漫画..."
                className="bg-transparent border-none outline-none w-full text-sm"
              />
            </div>
          </div>
        </div>
      )}
    </header>
  );
}